import { EventEmitter } from '@angular/core';
import { TemplateFieldDto } from '../../../admin/templates/templates-admin.model';
import { User } from '../../../../models/user.model';
import { FieldValueChange } from '../dynamic-field.component';

/**
 * Interface that all field type strategy components must implement.
 * Each strategy handles both the logic AND UI for a specific field type.
 */
export interface FieldTypeStrategy {
    /** The field definition from the template */
    field: TemplateFieldDto;

    /** Current value of the field */
    value: any;

    /** Available users for USER_SELECT fields */
    users: User[];

    /** Whether the field is in readonly display mode */
    readonly: boolean;

    /** Emits when the field value changes */
    valueChange: EventEmitter<FieldValueChange>;

    /**
     * Initialize the field with its current value.
     * Called when the field is first rendered or when value changes externally.
     */
    initialize(value: any): void;

    /**
     * Serialize the current value for API submission.
     * Handles type-specific serialization (e.g., arrays to JSON).
     */
    serialize(): any;

    /**
     * Optional validation of the current value.
     * Returns validation result with errors if invalid.
     */
    validate?(): FieldValidationResult;
}

export interface FieldValidationResult {
    valid: boolean;
    errors?: string[];
}
